import { useTranslation } from 'react-i18next';

import { MfaList, PageWrapper } from '@Components';
import { MfaElement } from '@Models';

interface MfaProps {
  phones: MfaElement[];
}

const Mfa = ({ phones }: MfaProps) => {
  const { t } = useTranslation();

  return (
    <div className="h-full w-full">
      <PageWrapper title={t('Mfa.Title')}>
        <div className="overflow-hidden rounded-xl border border-gray-200 bg-white">
          <div className="flex md:flex-row mx-6 my-4 items-center flex-col">
            <span className="font-bold text-xl justify-start text-gray-700">
              {`${t('Mfa.Message')} (${phones?.length ?? 0})`}
            </span>
          </div>
          <MfaList phones={phones ?? []} />
        </div>
      </PageWrapper>
    </div>
  );
};

export default Mfa;
